import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import {
  clearOverviewConversionsFilterMobileDataMap,
  resetOverviewConversionsMobileFilters,
} from "../../../../../../../../../features/bizDevelopmentDashboardMobileSlice";

interface ConversionsDetailsProps {
  dateType: string;
  setDateType: React.Dispatch<React.SetStateAction<string>>;
  setTimeUnit: React.Dispatch<React.SetStateAction<string>>;
}

const ConversionsDetails = ({
  dateType,
  setDateType,
  setTimeUnit,
}: ConversionsDetailsProps) => {
  const loadingOverviewConversionsMobileData = useSelector(
    (state: any) =>
      state.bizDevelopmentDashboardMobile?.loadingOverviewConversionsMobileData,
  );
  const dispatch = useDispatch();
  const value = dateType === "click_date" ? 1 : 0;

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const newType = newValue === 0 ? "action_date" : "click_date";
    setDateType(newType);
    setTimeUnit("day");
    dispatch(resetOverviewConversionsMobileFilters());
    dispatch(clearOverviewConversionsFilterMobileDataMap());
  };

  const tabConfig = [{ label: "Action Date" }, { label: "Click Date" }];

  return (
    <>
      <Typography
        sx={{
          fontSize: typography.Size.Text.md.$value,
          my: 1,
          fontWeight: typography.Font_weight.Medium.$value,
        }}
      >
        Trends Details
      </Typography>
      <Stack sx={{ my: 1 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          centered
          sx={{
            background: colors.GrayLightMode[100].$value,
            borderTop: "3px solid" + colors.GrayLightMode[100].$value,
            borderBottom: "3px solid" + colors.GrayLightMode[100].$value,
            borderRadius: spacing.Radius.md.$value,
            minHeight: spacing.Spacing["3xl"].$value,
          }}
          TabIndicatorProps={{ sx: { height: spacing.Spacing.none.$value } }}
        >
          {tabConfig.map((tab) => (
            <Tab
              key={tab.label}
              disabled={loadingOverviewConversionsMobileData}
              label={tab.label}
              disableRipple
              sx={{
                width: "49.1%",
                color: colors.GrayDarkMode[500].$value,
                textTransform: "none",
                fontWeight: typography.Font_weight.Regular.$value,
                borderRadius: spacing.Radius.xs.$value,
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                padding: 0,
                minHeight: spacing.Spacing["3xl"].$value,
                "&.Mui-selected": {
                  color: colors.GrayDarkMode[900].$value,
                  fontWeight: typography.Font_weight.Bold.$value,
                  backgroundColor: colors.Base.White.$value + "!important",
                },
                "&:hover": { backgroundColor: "transparent" },
              }}
            />
          ))}
        </Tabs>
      </Stack>
    </>
  );
};

export default ConversionsDetails;
